import { useState, useEffect, useCallback } from 'react';
import _ from 'underscore';
import Api from 'entities/helpers/api';

const useEmmaListFetcher = (listId, hasEmma) => {
  const [data, setData] = useState({ accounts: [], groups: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!listId) {
      setError('No List ID');
      return;
    }

    if (!hasEmma) {
      setError('Emma Not Enabled');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const accountsPromise = Api.EMMA.ACCOUNTS.get();
      const listPromise = Api.EMMA.LIST.get({ urlArgs: { list_id: listId } });

      const [accounts, list] = await Promise.all([accountsPromise, listPromise]);
      const groups = _.filter(list.groups, ({ account_id }) => _.findWhere(accounts, { id: account_id }));

      setData({ accounts, groups });
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [listId, hasEmma]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { ...data, loading, error, refresh: fetchData };
};

export default useEmmaListFetcher;
